import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createCustomerProfileActions,
  getCustomerProfileAction,
  getProfileActions,
  updateUserProfieAction,
} from "../../app/api/useDataManage/userActions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Select from "react-select";
import DashboardWrapper from "./components/DashboardWrapper";
import CustomerAddress from "./CustomerAddress";
import ChangePassword from "./ChangePassword";
import { useTranslation } from "react-i18next";
import { EmailAddress, FirstName, LastName, Phone } from "../../Constants";

function Profile() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { errorMessage, user, customerProfile } = useSelector(
    (state) => state.user
  );
  const genderOptions = [
    { value: "male", label: t("Profile_GenderMale") },
    { value: "female", label: t("Profile_GenderFemale") },
  ];
  const [token] = useState(localStorage.getItem("customer_token"));
  const [hasDisplayedError, setHasDisplayedError] = useState(true);

  useEffect(() => {
    if (token) {
      dispatch(getProfileActions(token));
      dispatch(getCustomerProfileAction(token));
    }
  }, [dispatch, token]);

  const [update, setUpdates] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    phone: "",
  });

  const handleCountryChange = (selectedOption) => {
    let target = { name: "gender", value: selectedOption.value };
    updateInputs({ target });
  };

  useEffect(() => {
    if (errorMessage !== "" && !hasDisplayedError) {
      toast.error(errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setHasDisplayedError(true);
    }
    if (errorMessage === "" && !hasDisplayedError) {
      toast.success(t("Profile_UpdateSuccess"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      setHasDisplayedError(true);
    }
  }, [errorMessage, hasDisplayedError, t]);

  useEffect(() => {
    // Update the 'update' state when the user data is available
    setUpdates({
      first_name: user?.name,
      last_name: customerProfile?.last_name,
      gender: customerProfile?.gender,
      phone: customerProfile?.phone,
    });
  }, [user, customerProfile]);

  const updateInputs = (e) => {
    //e.preventDefault()
    setUpdates({ ...update, [e.target.name]: e.target.value });
  };

  const updateHandler = (e) => {
    e.preventDefault();
    const updated = {
      token: token,
      user: update,
    };
    setHasDisplayedError(false);

    if (customerProfile === null || customerProfile === undefined) {
      dispatch(createCustomerProfileActions(updated));
    } else if (customerProfile !== null) {
      dispatch(updateUserProfieAction(updated));
    }
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "23px",
      height: "40px", // Adjust the height as needed
    }),
  };

  return (
    <DashboardWrapper title={t("Profile_PersonalInformation")}>
      <div className="col-xl-8 col-lg-8 user-inner">
        <div className="profile-reviews-wrapper t-flex t-flex-col t-gap-12">
          <div className="container">
            <div className="welcome mb-4">
              <h4 className="t-font-bold">{t("Profile_PersonalInformation")}</h4>
            </div>
            <form onSubmit={updateHandler}>
              <div className="row gy-4">
                <div className="col-lg-6 t-flex t-flex-col t-items-start t-gap-0 position-relative">
                  <label className="t-text-gray-600 !t-ml-0">{t(FirstName)}</label>
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    placeholder={t("Profile_EnterFirstName")}
                    className={`form-control t-h-[40px] !t-pl-3 ${
                      update?.first_name?.length < 3 ? "is-invalid" : ""
                    }`}
                    defaultValue={update.first_name}
                    onChange={updateInputs}
                    required
                    minLength={3}
                  />
                </div>
                <div className="col-lg-6 position-relative">
                  <label className="t-text-gray-600 !t-ml-0">{t(LastName)}</label>
                  <input
                    name="last_name"
                    id="last_name"
                    placeholder={t("Profile_EnterLastName")}
                    className={`form-control t-h-[40px] !t-pl-3 ${
                      update?.last_name?.length < 3 ? "is-invalid" : ""
                    }`}
                    defaultValue={update.last_name}
                    onChange={updateInputs}
                    required
                    minLength={3}
                  />
                </div>
                <div className="col-lg-12 position-relative">
                  <label className="t-text-gray-600 !t-ml-0">{t(EmailAddress)}</label>
                  <input
                    type="text"
                    name="email"
                    placeholder={t("Profile_EnterEmail")}
                    id="email"
                    className="form-control t-h-[40px] !t-pl-3"
                    value={user?.email}
                  />
                </div>
                <div className="col-lg-6 position-relative">
                  <label className="t-text-gray-600 !t-ml-0">{t(Phone)}</label>
                  <input
                    type="text"
                    name="phone"
                    id="phone"
                    placeholder={t("Profile_EnterPhone")}
                    className={`form-control t-h-[40px] !t-pl-3 ${
                      update?.phone?.length < 10 ? "is-invalid" : ""
                    }`}
                    value={update.phone}
                    onChange={updateInputs}
                  />
                </div>
                <div className="col-lg-6 position-relative rounded-pill">
                  <label className="t-text-gray-600 !t-ml-0">{t("Profile_Gender")}</label>
                  <Select
                    options={genderOptions}
                    value={genderOptions.find((c) => c.value === update.gender)}
                    onChange={handleCountryChange}
                    styles={customStyles}
                  />
                </div>
              </div>
              <div className="t-mt-6">
                <button
                  type="submit"
                  className="btn btn-custom-secondary fw-bold lts1 px-5"
                >
                  {t("Update")}
                </button>
              </div>
            </form>
          </div>
          <CustomerAddress />
          <ChangePassword />
        </div>
        <div className="blog-detail-inner"></div>
      </div>
    </DashboardWrapper>
  );
}

export default Profile;
